import React, { useState } from 'react';
import { hot } from 'react-hot-loader';

import IconMonitor from 'icons/icon-color-monitor.png';

const DeveloperModal = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) {
    return null;
  }

  return (
    <div id="recruit-modal" className="modal align-items-center justify-content-center">
      <div className="modal-dialog bg-white border-radius-5px border relative">
        <div className="modal-content text-center d-flex align-items-center flex-column padding-top-30px padding-bottom-30px padding-left-15px padding-right-15px">
          <button
            className="close border-none absolute"
            onClick={() => setVisible(false)}
            style={{ background: 'none' }}
            type="button"
          >
            <span>&times;</span>
          </button>
          <strong className="d-block c-guava-500">Gusto Engineering</strong>
          <h2 className="text-center">
            You are awesome. <span className="d-block">Let’s meet!</span>
          </h2>
          <p>
            Nice work! We’re flattered and impressed that you figured out our homepage puzzle. Any
            chance you’d consider working with us? Please send a resumé and an intro and we’ll get
            back to you.
            <br />
            Rock on, friend.
          </p>
          <img src={IconMonitor} alt="monitor icon" />
          <a className="btn primary margin-top-10px" href="/about/careers">
            Apply Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default hot(module)(DeveloperModal);
